import { useTheme } from "@mui/material";
import { type FC, useState } from "react";
import { AdvisorPageBody } from "web_myplann/Advisor/Components/AdvisorPageBody";
import { AdvisorPageHeader } from "web_myplann/Advisor/Components/AdvisorPageHeader";
import { AdvisorPickerDrawer } from "web_myplann/Advisor/Components/AdvisorPickerDrawer";
import { useAdvisorSelection } from "web_myplann/Advisor/Hooks/useAdvisorSelection";
import { useAdvisorsList } from "web_myplann/Advisor/Hooks/useAdvisorsList";
import { useSyncAdvisorsPendingCount } from "web_myplann/Advisor/Hooks/useSyncAdvisorsPendingCount";
import { shouldShowAdvisorPicker } from "web_myplann/Advisor/Utils/shouldShowAdvisorPicker";
import { useAdvisorDetailQuery } from "web_myplann/Api/Advisor/useAdvisorDetailQuery";
import { MyPlannLayout } from "web_myplann/Shared/Header/MyPlannLayout";

export const AdvisorPage: FC = () => {
	const theme = useTheme();
	const [pickerOpen, setPickerOpen] = useState(false);
	const {
		connectedAdvisors,
		pendingAdvisors,
		advisorsPending,
		isLoading: listLoading,
	} = useAdvisorsList();
	const { selected, selectAdvisor, clearSelection } =
		useAdvisorSelection(connectedAdvisors);
	const { data: detail, isLoading: detailLoading } = useAdvisorDetailQuery(
		selected?.uid,
	);
	const pendingCount = advisorsPending ?? 0;

	useSyncAdvisorsPendingCount(advisorsPending);

	return (
		<MyPlannLayout
			disableContentPadding
			bgColor={theme.palette.background.paper}
			topBar={
				<AdvisorPageHeader
					selected={selected}
					advisorsPending={pendingCount}
					showPicker={shouldShowAdvisorPicker(connectedAdvisors, pendingCount)}
					onOpenPicker={() => setPickerOpen(true)}
					onAdvisorDeleted={clearSelection}
				/>
			}
		>
			<AdvisorPageBody
				isLoading={listLoading || (Boolean(selected) && detailLoading)}
				selected={selected}
				detail={detail}
			/>

			<AdvisorPickerDrawer
				open={pickerOpen}
				onClose={() => setPickerOpen(false)}
				advisors={connectedAdvisors}
				pendingAdvisors={pendingAdvisors}
				pendingCount={pendingCount}
				selectedId={selected?.uid}
				onSelect={selectAdvisor}
			/>
		</MyPlannLayout>
	);
};
